'use es6';

import { Form } from 'foundations-components/transitional/components/Form';
import DataExportSelect from '../inputFields/DataExportSelect';
import EmailRecipientSelect from '../inputFields/EmailRecipientSelect';
import EmailExternalRecipientSelect from '../inputFields/EmailExternalRecipientSelect';
import EmailSubjectTextInput from '../inputFields/EmailSubjectTextInput';
import ShareCadenceOptions from '../inputFields/ShareCadenceOptions';
import ShareScheduledNicknameTextInput from '../inputFields/ShareScheduledNicknameTextInput';
import ShareMessageTextInput from '../inputFields/ShareMessageTextInput';
import { View } from 'foundations-components/components/View';
import { useControlsContext } from '../context';
import ShareScheduling from '../inputFields/ShareScheduling';
import { useHasReportingAdminAccess, useHasEmailExternalRecipientsAccess } from '../../../access/scopes/hooks/useHasScope';
import { isUnsupportedDataExportType } from '../../shared/emailLogic';

// TODO: Add resetSelectedReports when sharing with Dashboard
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailAssetDialog = ({
  appUsageTracker
}) => {
  const {
    dataExportType,
    isEditingScheduledEmail,
    isRecurringShareAsset
  } = useControlsContext();
  const isAdmin = useHasReportingAdminAccess();
  const hasEmailExternalRecipientsAccess = useHasEmailExternalRecipientsAccess();
  const shouldRenderEmailExternalField = isAdmin && !isRecurringShareAsset && hasEmailExternalRecipientsAccess && !isUnsupportedDataExportType(dataExportType);
  return (
    /*#__PURE__*/
    // TODO: add handleSubmit <UIForm autoComplete="off" onSubmit={handleSubmit}>
    _jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Form, {
        "data-test-id": "share-report-via-email-form",
        autoComplete: "off",
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [!isEditingScheduledEmail && /*#__PURE__*/_jsx(ShareCadenceOptions, {}), isRecurringShareAsset && /*#__PURE__*/_jsx(ShareScheduledNicknameTextInput, {}), /*#__PURE__*/_jsx(EmailRecipientSelect, {}), /*#__PURE__*/_jsx(DataExportSelect, {}), shouldRenderEmailExternalField && /*#__PURE__*/_jsx(EmailExternalRecipientSelect, {
            appUsageTracker: appUsageTracker
          }), /*#__PURE__*/_jsx(EmailSubjectTextInput, {}), /*#__PURE__*/_jsx(ShareMessageTextInput, {}), (isRecurringShareAsset || isEditingScheduledEmail) && /*#__PURE__*/_jsx(ShareScheduling, {})]
        })
      })
    })
  );
};
export default EmailAssetDialog;